import { IShoppingCartState } from '@/@types'

const state: IShoppingCartState = {
  shoppingCart: [],
  recurlyPricing: {},
  bundleProductHasError: false,
  showPromotionSavings: false,
}

export default state
